import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferOffer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { SUC_REJ_XFER_OFF, ERR_REJ_XFER_OFF } from '../../../../utils/strings';

export const useRejectTransferOffer = () => {
  const { submit } = useExerciseSubmission(
    TransferOffer.TransferOffer_Reject,
    SUC_REJ_XFER_OFF,
    ERR_REJ_XFER_OFF,
  );
  return submit;
};
